import React, { useState, useEffect } from 'react' 
import { useNavigate,useLocation, Link } from 'react-router-dom';

import axios from "axios";
import * as Yup from "yup";
import { useFormik} from "formik";
import swal from "sweetalert";

export default function UserEdit() {
  const {state:{id}} = useLocation();
  const nav = useNavigate();
  const [inputs,setInputs] = useState({});

  const [nameError , setNameError] = useState('')
  const [emailError , setEmailError] = useState('')
  const [phoneNumberError , setPhoneNumber] = useState('')

  console.log(' :Load Data: ', id);
  useEffect(()=>{
    console.log(' :Load Data: ', id);
    fetchUser()
  },[]);

  const fetchUser = () => {
    axios.get(process.env.REACT_APP_API_KEY + "api/admin/user-edit/"+id, 
    {
      headers: {
      "Content-type": "Application/json",
      "Authorization": `Bearer 19|TNvDJvvnSustycqsXclnbH8S9hwbyy5xZVV9NhsE`
      }   
    })
    .then((res) => {
      if(res.data.status == true) {
        console.log(">>>>>>", res.data.user.phone_number)
        setInputs({
          name:res.data.user.name,
          email:res.data.user.email,
          phone_number:res.data.user.phone_number,
          status:res.data.user.status,
          role_type:res.data.user.role_type,
        })
        console.log("setInputs =>", setInputs);
      }
    }).catch(error => {
      //
    })    
  }
  
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs(values => ({...values,[name]:value}))
  }
  
  const updateUser = () =>{
    console.log('inputs=> ', inputs)
    axios.post(process.env.REACT_APP_API_KEY + "api/admin/user-update/"+id,inputs,{
      //axios.put(process.env.REACT_APP_API_KEY+"api/user-update/"+id,inputs, 
        headers: {
        "Content-type": "Application/json",
        "Authorization": localStorage.getItem("token")
        }   
      }
      ).then((res)=>{
        //Check for Authorized
        if(res.data.code == 403){
          localStorage.clear();
          nav('/admin/login');
        }

        swal({
          title: "Wow!",
          text: res.data.message,
          icon: "success",
          button: "Okay",
        });
        nav('/admin/users-list');
      }).catch(error => {
        if (!error.response.data.status) {
          const resdata = error.response.data.errors;
          console.log(resdata);
          Object.keys(resdata).forEach(function(key) {
            console.log("key =>", key ," value => ", resdata[key]);
            if(key == 'name'){
              setNameError(resdata[key]);
            }
            if(key == 'email'){
              setEmailError(resdata[key]);
            }
            
            if(key == 'phone_number'){
              setPhoneNumber(resdata[key]);
            }
            console.log('Key : ' + key + ', Value : ' + resdata[key])
          })
        } else {
          swal("Oops", "Unauthorized User", "error");
        }
      console.log('aya',error.response.data);
      })
  }


  return (
          <div className="wrapper">
          
          <div className="content-wrapper">

      <form  className="mx-5 col-md-5">
        <h2>Edit User</h2>
        
        <div className="ui form box-body">
          <div className="field form-group">               
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              autoComplete="nope"
              placeholder="Full Name"             
              className="form-control"
              onChange={handleChange}
              value={inputs.name}   
            />
            <div className="text-danger">
            {nameError ?  nameError : null}
            </div>
          </div>
          
          <div className="field form-group">               
            <label>Email Address</label>
           
            <input
              type="text"
              name="email"
              autoComplete="nope"
              placeholder="Email Address"            
              className="field form-control"
              onChange={handleChange}
              value={inputs.email}   
            />
            <div className="text-danger">
            {emailError ?  emailError : null}
            </div>
          </div>
          
          <div className="field form-group">               
            <label>Phone number</label>
            <input
              type="text"
              name="phone_number"
              autoComplete="nope"
              placeholder="Phone number"              
              className="field form-control"
              onChange={handleChange}
              value={inputs.phone_number}   
            />
            <div className="text-danger">
                {phoneNumberError ?  phoneNumberError : null}
              </div>
          </div>
          <div className="field form-group">               
            <label>User Role</label>
            <select className='form-control' name='role_type' onChange={handleChange} value={inputs.role_type} >
              <option value="Admin">Admin</option>
              <option value="SubAdmin">Sub Admin</option>
            </select>
          </div>
          <div className="field form-group">               
            <label>Status</label>
            <select className='form-control' name="status" onChange={handleChange} value={inputs.status} >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
              
            </select>
          </div>
          <div className='btn-allign'>
          <button type="button" onClick={updateUser} className="btn btn-danger submit-btn">Save</button>
          <Link to="/admin/users-list"><button className="btn btn-primary submit-btn">Back</button></Link>
          </div>
        </div>
      </form>
    </div>
          
          </div>
  )
}